import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../library/assets/Arrow_alt_ltop.svg'
import _imports_1 from '../library/assets/social-banner-logo.png'
import _imports_2 from '../library/assets/tick.svg'


const _withScopeId = n => (_pushScopeId("data-v-30b4f882"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = {
  key: 0,
  class: "row mb-4"
}
const _hoisted_3 = { class: "col text-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "asahi-bs-footer" }
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12 col-lg col-fixed-width brand" }
const _hoisted_9 = { class: "col asahi-bs-footer-accordion" }
const _hoisted_10 = {
  class: "accordion",
  id: "asahi-bs-footer-accordion"
}
const _hoisted_11 = ["data-bs-target", "aria-controls"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-accordion-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1 4L8 11L15 4",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_13 = ["id"]
const _hoisted_14 = { class: "accordion-body" }
const _hoisted_15 = ["href", "onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "arrow-alt-ltop"
}, null, -1))
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  src: _imports_0,
  class: "arrow-alt-ltop"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = ["href", "onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "p-1" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "footer-logo",
  src: _imports_1
}, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = { class: "language-picker-container" }
const _hoisted_26 = { class: "asahi-bs-footer-accordion-language" }
const _hoisted_27 = { class: "accordion-item" }
const _hoisted_28 = { class: "accordion-header" }
const _hoisted_29 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": '#asahi-bs-footer-accordion-collapse-language',
  "aria-expanded": "false",
  "aria-controls": 'asahi-bs-footer-accordion-collapse-language'
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-accordion-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1 4L8 11L15 4",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_31 = {
  id: 'asahi-bs-footer-accordion-collapse-language',
  class: "accordion-collapse collapse"
}
const _hoisted_32 = { class: "accordion-body" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "asahi-language" }
const _hoisted_35 = {
  key: 0,
  class: "language-selected-icon",
  src: _imports_2
}
const _hoisted_36 = { class: "container text-center" }
const _hoisted_37 = { class: "row justify-content-center" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-auto" }, " © Copyright Asahi CE & Europe Services s.r.o., 2024 ", -1))
const _hoisted_39 = { class: "col-12 col-lg-auto footer-links" }
const _hoisted_40 = ["href", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiLogoNew = _resolveComponent("AsahiLogoNew")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SocialBannerNew = _resolveComponent("SocialBannerNew")!
  const _component_AsahiTypography = _resolveComponent("AsahiTypography")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.$route.name === 'homepage')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToTop()))
              }, [
                _createElementVNode("img", {
                  src: _ctx.angleCircleUp,
                  alt: "Angle up circled icon"
                }, null, 8, _hoisted_4)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_AsahiLogoNew, {
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.navigateToPath({label: 'Logo', link: '/' })), ["prevent"]))
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combinedFooterData, (value, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "accordion-item",
                  key: value.name
                }, [
                  (value.label && value.name !== 'products_catalogue')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["accordion-header", [value.label === 'Create an order' ? 'd-none' : '']])
                      }, [
                        _createElementVNode("button", {
                          class: "accordion-button collapsed",
                          type: "button",
                          "data-bs-toggle": "collapse",
                          "data-bs-target": '#asahi-bs-footer-accordion-collapse-' + index,
                          "aria-expanded": "false",
                          "aria-controls": 'asahi-bs-footer-accordion-collapse-' + index
                        }, [
                          _createElementVNode("span", null, _toDisplayString(value.label), 1),
                          _hoisted_12
                        ], 8, _hoisted_11)
                      ], 2))
                    : _createCommentVNode("", true),
                  (value.label)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        id: 'asahi-bs-footer-accordion-collapse-' + index,
                        class: "accordion-collapse collapse"
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.children, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.label,
                              class: "py-2"
                            }, [
                              (_ctx.isExternal(item.href) && item?.name !== 'eLearning' && item?.name !== 'Pub Menu')
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: item.href,
                                    class: "external-link",
                                    target: "_blank",
                                    onClick: ($event: any) => (_ctx.trackExternalLink(item))
                                  }, [
                                    _createTextVNode(_toDisplayString(item.label) + " ", 1),
                                    _hoisted_16
                                  ], 8, _hoisted_15))
                                : (item.href && item?.name !== 'eLearning' && item?.name !== 'Pub Menu')
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 1,
                                      to: item.href
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.label), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to"]))
                                  : (_openBlock(), _createElementBlock("span", {
                                      key: 2,
                                      onClick: ($event: any) => (_ctx.menuNavigate(item)),
                                      class: "external-link"
                                    }, [
                                      _createTextVNode(_toDisplayString(item.label) + " ", 1),
                                      (item.name == 'Pub Menu' || item.name == 'eLearning')
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_18))
                                        : _createCommentVNode("", true)
                                    ], 8, _hoisted_17))
                            ]))
                          }), 128))
                        ])
                      ], 8, _hoisted_13))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.combinedFooterData, (section) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 col-md col-fixed-width asahi-bs-footer-menu",
              key: section.title
            }, [
              _createElementVNode("p", {
                href: section.link,
                class: "footer-section-title"
              }, _toDisplayString(section.title || section.label), 9, _hoisted_19),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((section.links || section.children), (link) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: link.label
                }, [
                  (_ctx.isExternal(link.href) && link?.name !== 'eLearning' && link?.name !== 'Pub Menu')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: link.href,
                        class: "external-link",
                        target: "_blank",
                        onClick: ($event: any) => (_ctx.trackExternalLink(link))
                      }, _toDisplayString(link.label), 9, _hoisted_20))
                    : (link.label && link?.name !== 'eLearning' && link?.name !== 'Pub Menu')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: (link.href || link.link) || '',
                          href: (link.href || link.link),
                          target: section.links ? '_blank' : '',
                          rel: "noopener noreferrer",
                          class: "external-link",
                          onClick: _withModifiers(($event: any) => (_ctx.navigateToPath(link)), ["prevent"])
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(link.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "href", "target", "onClick"]))
                      : (link?.label)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 2,
                            onClick: ($event: any) => (_ctx.menuNavigate(link)),
                            class: "external-link"
                          }, _toDisplayString(link.label), 9, _hoisted_21))
                        : _createCommentVNode("", true)
                ], 64))
              }), 128))
            ]))
          }), 128)),
          _createElementVNode("div", {
            class: _normalizeClass([[_ctx.isLoggedIn ? 'col-lg' : 'col-lg-2 col-md-6'], "col-12 col-fixed-width social-banner-section"])
          }, [
            _createVNode(_component_SocialBannerNew),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("a", {
                href: "https://www.alcolparliamone.it",
                target: "_blank",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trackExternalLink({ label: 'alcolparliamone.it', href: 'https://www.alcolparliamone.it' })))
              }, [
                _hoisted_23,
                _hoisted_24,
                _createVNode(_component_AsahiTypography, { type: "body-1-bold text-white text-decoration-none" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" www.alcolparliamone.it ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", _hoisted_29, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getFullLanguageName(_ctx.activeLanguage)), 1),
                      _hoisted_30
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.language, (lang) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: lang,
                          class: "py-2 clickable",
                          onClick: ($event: any) => (_ctx.changeLanguage(lang))
                        }, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("p", {
                              class: _normalizeClass(["asahi-lang-label", { 'selected-language': _ctx.activeLanguage === lang }])
                            }, _toDisplayString(_ctx.getFullLanguageName(lang)), 3),
                            (_ctx.activeLanguage === lang)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_35))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_33))
                      }), 128))
                    ])
                  ])
                ])
              ])), [
                [_directive_click_outside, _ctx.closeLangAccordion]
              ])
            ])
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["asahi-bs-footer-copyright", {'pb-90' : _ctx.isUserManagementPage}])
    }, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footerBottomLinks, (lnk, index) => {
              return (_openBlock(), _createElementBlock("a", {
                key: index,
                href: lnk?.url,
                target: "_blank",
                onClick: ($event: any) => (_ctx.trackExternalLink({ label: lnk?.label, href: lnk?.url }))
              }, _toDisplayString(_ctx.$t(lnk?.label)), 9, _hoisted_40))
            }), 128))
          ])
        ])
      ])
    ], 2)
  ], 64))
}